<template>
<!--oncontextmenu="return false;"-->
<div>

<v-content >
    
<div class="my-12 mx-3" >

  <div class="loading" v-if="loading">
    <div class="loader" ></div>
</div>
    <v-row class="mb-4" >
         <v-col
        
        cols="2"
        sm="2"
      >
      
<v-card
    max-width="450"
    class="mx-auto"
    min-height="320"
  >

    <v-toolbar
      color="#AD8744"
      dark
    >

      <v-toolbar-title>Lines</v-toolbar-title>

      <v-spacer></v-spacer>


    </v-toolbar>

<v-list style="max-height: 59vh" class="overflow-y-auto" >
        <v-list-item-group
        v-model="selectedLineIndex"
        mandatory
        color="#AD8744"
      >
    <v-list-item
          v-for="(item, i) in sentences"
          :key="i"
          @click="selectedLineIndex = i"
        >
          <v-list-item-content>
            <v-list-item-title > <label class="font-weight-bold">{{i + " -   "}}</label>{{item}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list-item-group>
</v-list>
  </v-card>
         </v-col>
            <v-col

      >
            <v-card class="pa-4" elevation="6">
           <v-card-title class="pa-0">
            <v-card
              class="mx-3 mb-3"
              color="#AD8744"
              style="margin-top: -30px"
              elevation="4"
              width="100%"
            >
              <v-card-title>
                <h4 class="font-weight-light text-h5" style="color: #ffffff">
                        Annotator
                           
                </h4>
              </v-card-title>
            </v-card> 
          </v-card-title>
          <v-card-text id="anotator">
              <v-col v-if="annotations.length != 0"
              cols="12"
            >
            <v-row class="px-4">
              <v-col class= "ma-0 pa-0" cols="11">
            <label class="font-weight-bold text-lg-h6">Line: {{selectedLineIndex}}</label>

            <label class="ml-9" style=" line-height: 3.4;white-space: normal;">
              <a  class='font-weight-bold' @click="labelsDialog =true" style="text-decoration: none;">
                <mark class="entity" :style={background:label1Color}>
                    {{label1}}
                  <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">Key: {{label1Key}}</span>
                </mark>
              </a>
            </label>
                        <label class="ml-3" style=" line-height: 3.4;white-space: normal;" >
              <a  class="font-weight-bold"  @click="labelsDialog =true" style="text-decoration: none;">
                <mark class="entity" :style={background:label2Color}>
                    {{label2}}
                  <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">Key: {{label2Key}}</span>
                </mark>
              </a>
            </label>
            <label class="ml-3" style=" line-height: 3.4;white-space: normal;" >
              <a  class="font-weight-bold"  @click="labelsDialog =true" style="text-decoration: none;">
                <mark class="entity" :style={background:label3Color}>
                    {{label3}}
                  <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">Key: {{label3Key}}</span>
                </mark>
              </a>
            </label>
            <label class="ml-3" style=" line-height: 3.4;white-space: normal;" >
              <a  class='font-weight-bold' @click="labelsDialog =true"  style="text-decoration: none;">
                <mark class="entity" :style={background:label4Color}>
                    {{label4}}
                  <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">Key: {{label4Key}}</span>
                </mark>
              </a>
            </label>
            <label class="ml-3" style=" line-height: 1.4;white-space: normal;" >
              <a  class='font-weight-bold'  @click="labelsDialog =true" style="text-decoration: none;">
                <mark class="entity" :style={background:label5Color}>
                    {{label5}}
                  <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">Key: {{label5Key}}</span>
                </mark>
              </a>
            </label>

            
            
              </v-col>
            <v-col class= "ma-0 pa-0 .flex-nowrap" cols="1">
                     <v-select
          :items="textSizes"
          v-model="textSize"
          item-text="text"
          item-value="class"
          label="Text Size:"
          dense
          style="height:40px; margin-top:10px"

        ></v-select>
            </v-col>
            </v-row>

            <div  class="entities  pa-4 mt-3" style=" min-height:250px; line-height: 2.5; direction: ltr; background: #F4F4F4; border-radius: 10px;">
            <span v-for="(token,j) in processLine" 
            :key="j" ref="target">
          <template v-if="token[1]=='O'">
            <v-menu
            disabled
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
    >
      <template v-slot:activator="{on, attrs}">
        <label style=" line-height: 3.4;white-space: normal;" >
          <a :class="textSize  "   style="color: black; "  v-bind="attrs" :data-tokenIndex="j" data-flag="biotoken"
          v-on="on" @mouseover="()=>{lineIndex = selectedLineIndex; tokenIndex = j}" @mouseleave="()=>{lineIndex = -1; tokenIndex = -1}"
              >{{token[0]}} </a>  <!--<span style="margin-right:1.5px"></span>  -->
       
        </label>
      
      </template>

      <v-card>
        <v-list>
          <v-list-item class="text-center">
            <v-list-item-content>
              <v-list-item-title class="font-weight-black">Labels </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
                <v-icon color="#AD8744">mdi-label</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item>
              <v-btn :color="label1Color" small class="ml-4" @click="annotate(selectedLineIndex,j,label1,'B')">
              Organizacao
            </v-btn >
              <v-btn :color="label2Color" small class="ml-4" @click="annotate(selectedLineIndex,j,label2,'B')">
              Pessoa
            </v-btn>
            <v-btn :color="label3Color" small class="ml-4" @click="annotate(selectedLineIndex,j,label3,'B')">
              Local
            </v-btn>
            <v-btn :color="label4Color" small class="ml-4" @click="annotate(selectedLineIndex,j,label4,'B')">
              Profissao
            </v-btn>
            <v-btn :color="label5Color" small class="ml-4" @click="annotate(selectedLineIndex,j,label5,'B')">
              Data
            </v-btn>
          </v-list-item>
          <v-divider></v-divider>
                   <v-list-item>
         <v-btn  v-if="items[selectedLineIndex][j-1] != undefined && (items[selectedLineIndex][j-1][1] == 'I' || items[selectedLineIndex][j-1][1] == 'B')" small class="ml-4" :color="getLabelColor(selectedLineIndex,j-1)" @click="annotate(selectedLineIndex,j,items[selectedLineIndex][j-1][2],'I')">
           {{items[selectedLineIndex][j-1][2]}}
         </v-btn>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
              
          </template>
          <template v-else-if="token[1]=='B'">
            <label style=" line-height: 3.4;white-space: normal;" :data-tokenIndex="j" data-flag="biotoken">
        <a  :class="textSize + 'font-weight-bold'" @click="removeAnnotation(selectedLineIndex,j)" style="text-decoration: none;"
        @mouseover="()=>{lineIndex = selectedLineIndex; tokenIndex = j}" @mouseleave="()=>{lineIndex = -1; tokenIndex = -1}">
<mark class="entity" :style={background:getLabelColor(selectedLineIndex,j)}>
    {{token[0]}}
    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">{{token[2]}}</span>
</mark>
</a>
            </label>
          </template>
            </span>
            <div class="mt-12 text-center ">
             <v-btn
              x-large
              color="success"
              dark
              class="mx-3"
              @click="accept()"
            >
              Accept <v-icon >mdi-check</v-icon>
            </v-btn>
                         <v-btn
              x-large
              color="error"
              dark
              class="mx-3"
              @click="reject()"
            >
              Reject <v-icon >mdi-delete</v-icon>
            </v-btn>
                                     <v-btn
              x-large
              color="#a3a3a3"
              dark
              class="mx-3"
              @click="back()"
            >
               <v-icon >mdi-arrow-left</v-icon>
            </v-btn>
            </div>
</div>
  <v-expansion-panels class="mt-9">
    <v-expansion-panel>
      <v-expansion-panel-header>
        Generated Array
      </v-expansion-panel-header>
      <v-expansion-panel-content>

      <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-wrap">{{items[selectedLineIndex]}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item> 
     <v-list-item v-if="debugMode">
      <v-list-item-content>
        <v-list-item-title class="text-wrap"></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
              </v-col>

              <v-col v-else>
                <FileDragDrop @readLocalFile="readLocalFile"/>

              </v-col>
        <v-row v-if="annotations.length == 0" class="pa-4 mt-4 text-center" align="center" justify="center">


          <input ref="stateFile" type="file" hidden @change="loadAnnotatorState">
              <v-btn small type='submit' @click="$refs.stateFile.click()"> <v-icon color="#AD8744" class="pr-2">mdi-file</v-icon>  Load saved file  </v-btn>
    <v-btn small class="ml-5" type='submit' @click="loadAnnotatorExample"> <v-icon color="#AD8744" class="pr-2">mdi-eye</v-icon>  Load Example  </v-btn>
        </v-row>

          </v-card-text>
        </v-card>
        <v-row v-if="annotations.length > 0" class="pa-4 mt-4 text-center" align="center" justify="center">
              <v-btn x-large  type='submit' @click="this.$refs.annotationOptions.getAnnotationsEntityCount"> 
                <v-icon x-large color="#AD8744" class="pr-2">mdi-arrow-right-drop-circle</v-icon>  
                Train 

                </v-btn>

        </v-row>

            </v-col >
    <AnnotationOptions  ref ="annotationOptions" class="ml-3" :label1Color.sync="label1Color"
      :label2Color.sync="label2Color"
      :label3Color.sync="label3Color"
      :label4Color.sync="label4Color"
      :label5Color.sync="label5Color"
      :label1 ="label1"
      :label2 ="label2"
      :label3 ="label3"
      :label4 ="label4"
      :label5 ="label5"
      :label1Key.sync ="label1Key"
      :label2Key.sync ="label2Key"
      :label3Key.sync ="label3Key"
      :label4Key.sync ="label4Key"
      :label5Key.sync ="label5Key"
      :deleted.sync="deleted"
      :annotationsDialog.sync="annotationsDialog"
      :labelsDialog.sync="labelsDialog"
      :items="items"
      :annotations="annotations"
      @selectItems="selectItems"
      @train="train"
      @readLocalFile="readLocalFile"
      @exportJSON="exportJSON"
      @exportBIO="exportBIO"
      @exportBILUO="exportBILUO"
      @saveAnnotatorState="saveAnnotatorState"
      @restore="restore"/>
    </v-row>

          <!--
             <v-file-input show-size v-model="file" label="Select a file to Process."></v-file-input>
             <v-btn  type='submit' @click="readLocalFile"> Process File </v-btn> -->
             
    </div>

    </v-content>
</div>
<!--
   <v-list-item           
          v-for="(item, i) in items"
          :key="i">
      <v-list-item-content>
        <v-list-item-title>{{item}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
-->
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import AnnotationOptions from '@/components/AnnotationOptions.vue'
import FileDragDrop from '@/components/FileDragDrop.vue'
const dataAPI = require("@/config/hosts").dataAPI;
const example = require("@/files/annotatorStateExample").data;

export default {
      components: {
      AnnotationOptions,
      FileDragDrop
    },
 data() {
    return {
            items :[],
            newitems: [],
            corpus:"",
            annotations:[], //[[["Pequena", "O", ""], ["rua", "O", ""], [",", "O", ""], ["entre", "O", ""], ["a", "O", ""], ["rua", "O", ""], ["Nova", "B", "Data"], ["e", "O", ""], ["a", "O", ""], ["Porta", "B", "Local"], ["de", "I", "Local"], ["S.", "I", "Local"], ["Francisco", "I", "Local"], [",", "O", ""], ["existente", "O", ""], ["ja", "O", ""], ["na", "O", ""], ["Idade", "O", ""], ["Media", "O", ""], [",", "O", ""], ["entao", "O", ""], ["com", "O", ""], ["o", "O", ""], ["nome", "O", ""], ["de", "O", ""], ["rua", "O", ""], ["Nova", "O", ""], [".", "O", ""], ["\n", "O", ""]]],[[["Pequena", "O", ""], ["rua", "O", ""], [",", "O", ""], ["entre", "O", ""], ["a", "O", ""], ["rua", "O", ""], ["Nova", "B", "Data"], ["e", "O", ""], ["a", "O", ""], ["Porta", "B", "Local"], ["de", "I", "Local"], ["S.", "I", "Local"], ["Francisco", "I", "Local"], [",", "O", ""], ["existente", "O", ""], ["ja", "O", ""], ["na", "O", ""], ["Idade", "O", ""], ["Media", "O", ""], [",", "O", ""], ["entao", "O", ""], ["com", "O", ""], ["o", "O", ""], ["nome", "O", ""], ["de", "O", ""], ["rua", "O", ""], ["Nova", "O", ""], [".", "O", ""], ["\n", "O", ""]]]
            itemIndex: 0,
            batchNumber: 1,
            loadedFile: [],
            batchsize: 100,
            maxN: -1,
            minN: -1,
            file:[],
            sentences:[],
            lineIndex: -1,
            selectedLineIndex: 0,
            tokenIndex: -1,
            deleted:[],
            loading:false,
            debugMode:true,
            annotationsDialog:false,
            labelsDialog:false,
            textSize:"text-lg-h6 font-weight-regular",
            textSizes:[
              {text:"Large", class:"text-lg-h6 font-weight-regular"},
              {text:"Normal", class:"text-md-body-1 "},
              {text:"Small", class:"text-sm-body-2 "}
            ],
            label1Color:"#ddd", //#E4E7D2 #ddd
            label2Color:"#7AECEC",
            label3Color:"#AA9CFC",
            label4Color:"#FECA74",
            label5Color:"#BFE1D9",
            label1:"Organizacao",
            label2:"Pessoa",
            label3:"Local",
            label4:"Profissao",
            label5:"Data",
            label1Key:"1",
            label2Key:"2",
            label3Key:"3",
            label4Key:"4",
            label5Key:"5",
    }
  },
  mounted(){

      /*var selection = window.getSelection();
      console.log(selection)
var range = selection.getRangeAt(0);
console.log(range)
console.log(range.commonAncestorContainer.getElementsByTagName("label"))
//if(  range.commonAncestorContainer.getElementsByTagName("label") == "undefined") return;
var allWithinRangeParent = range.commonAncestorContainer.getElementsByTagName("label");

var allSelected = [];
for (var i=0, el; el = allWithinRangeParent[i]; i++) {
  // The second parameter says to include the element 
  // even if it's not fully selected
  if (selection.containsNode(el, true) ) {
    allSelected.push(el);
    console.log(el.dataset.tokenindex)
  }
}


console.log('All selected =', allSelected);*/

  },

  created() {
    this.createSetences()
    window.addEventListener('keydown', (e) => {
          var selection = window.getSelection();
          var label = ""
        if (e.keyCode == 16) {
          this.innerEntity()
          return
        }
        if (e.key == this.label1Key) {
          label = this.label1
        }
        if (e.key == this.label2Key) {
          label = this.label2
        }
        if (e.key == this.label3Key) {
          label = this.label3 
        }
        if (e.key == this.label4Key) {
          label = this.label4 
        }
        if (e.key == this.label5Key) {
          label = this.label5 
        }
        if(label == "") return
      if(selection.isCollapsed == true){
        this.beginEntity(label)
      }
      else{
       this.annotateSelection(label)
      }
    });
  },
  methods:{ 
        nextNode(node) {
            if (node.hasChildNodes()) {
                return node.firstChild;
            } else {
                while (node && !node.nextSibling) {
                    node = node.parentNode;
                }
                if (!node) {
                    return null;
                }
                return node.nextSibling;
            }
        },

        getRangeSelectedNodes(range) {
            var node = range.startContainer;
            var endNode = range.endContainer;
            // Special case for a range that is contained within a single node
            if (node == endNode) {
              if(node.parentNode.dataset.flag=="biotoken"){
                return [node.parentNode];
              }
              return []
            }

            // Iterate nodes until we hit the end container
            var rangeNodes = [];
            while (node && node != endNode) {
              node = this.nextNode(node)
              if(node.dataset != undefined && node.dataset.flag=="biotoken")
                rangeNodes.push(node);
            }

            // Add partially selected nodes at the start of the range
            node = range.startContainer;
            while (node && node != range.commonAncestorContainer) {
              if(node.dataset != undefined && node.dataset.flag=="biotoken")
                rangeNodes.unshift(node);
                node = node.parentNode;
            }

            return rangeNodes;
        },

        getSelectedNodes() {
            if (window.getSelection) {
                var sel = window.getSelection();
                if (!sel.isCollapsed) {
                    return this.getRangeSelectedNodes(sel.getRangeAt(0));
                }
            }
            return [];
        },


    exportJSON:function(){
        this.annotations[this.itemIndex] = this.items
        var aux = JSON.stringify(this.annotations.flat(1))
        let filename = 'AnnotatedCorpus.json';
        let element = document.createElement('a');
        element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(aux));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();
        document.body.removeChild(element);  
    },

        saveAnnotatorState:function(){
        var aux = JSON.stringify(this.$data)
        let filename = 'annotatorState.json';
        let element = document.createElement('a');
        element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(aux));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();
        document.body.removeChild(element);  
    },

    loadAnnotatorExample:function(){

      Object.assign(this.$data, example);
                 const annotator = document.getElementById('anotator');
          
          annotator.addEventListener('mouseup', event => {
          var nodes = this.getSelectedNodes()
          if(nodes.length == 0) return;
          this.maxN = nodes[nodes.length-1].dataset.tokenindex
          this.minN = nodes[0].dataset.tokenindex

        });
      
    },
        loadAnnotatorState:function(){
          var file = this.$refs.stateFile.files[0]
          console.log(this.$refs.stateFile.files[0])
        
        const reader = new FileReader();
       // if (this.file.name.includes(".txt") || this.file.name.includes(".xml")) {
          reader.onload = (res) => {
            console.log(res.target.result)
            Object.assign(this.$data, JSON.parse(res.target.result));

          const annotator = document.getElementById('anotator');
          
          annotator.addEventListener('mouseup', event => {
          var nodes = this.getSelectedNodes()
          this.maxN = nodes[nodes.length-1].dataset.tokenindex
          this.minN = nodes[0].dataset.tokenindex

        });
          };
          reader.onerror = (err) => console.log(err);
          reader.readAsText(file);
       // }
      
    },

        exportBIO:function(){
          this.annotations[this.itemIndex] = this.items
          
          let formData = new FormData();
          var x = this.annotations
          x.forEach(e => e.forEach(e1=> e1.splice(e1.length-1,1)))
          var aux = JSON.stringify(x.flat(1))
          var annFile = new File([aux], "ficheiro", {type: "text/plain", lastModified: new Date()})
          formData.append("ficheiro", annFile)
          this.loading=true
 
        axios.post(dataAPI+'annotator/export/bio',
          formData,
          {"timeout": 3000000},
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then((dados) => { 
          const url = window.URL.createObjectURL(new Blob([dados.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'AnnotatedCorpus.bio'); //or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);  
          this.loading=false

        })
        .catch((error)=>{this.loading=false})
      },

        exportBILUO:function(){
        this.annotations[this.itemIndex] = this.items
        var aux = JSON.stringify(this.annotations.flat(1))
        let filename = 'AnnotatedCorpus.json';
        let element = document.createElement('a');
        element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(aux));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();
        document.body.removeChild(element);  
    },

    readLocalFile:function(file){
        const reader = new FileReader();
       // if (this.file.name.includes(".txt") || this.file.name.includes(".xml")) {
          reader.onload = (res) => {

            var aux = res.target.result;
            this.corpus = aux.split(/\r\n|\n\r|\n|\r/).filter(e => e!="")
            for(var i in this.corpus){
              this.corpus[i] = this.corpus[i] + "\n"
            }
            this.postUnstructuredTextFile(file)
          };
          reader.onerror = (err) => console.log(err);
          reader.readAsText(file);
       // }
      
    },
    postUnstructuredTextFile: function(file){
        if  (file == "") { alert("Please select a file!"); return false;}
        let formData = new FormData();
          var text = this.corpus.slice(0,this.batchsize)
          var f = new File(text, "ficheiro", {type: "text/plain", lastModified: new Date()})
          formData.append("ficheiro", f)
          this.loading=true
 
        axios.post(dataAPI+'annotator/unstructuredText/file',
          formData,
          {"timeout": 3000000},
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then((dados) => { 
          this.annotations = []
          this.annotations.push(dados.data)
          this.items = this.annotations[0]
          this.createSetences()
          this.loading=false
          const annotator = document.getElementById('anotator');
          
          annotator.addEventListener('mouseup', event => {
          var nodes = this.getSelectedNodes()
          this.maxN = nodes[nodes.length-1].dataset.tokenindex
          this.minN = nodes[0].dataset.tokenindex

        });

        })
        .catch((error)=>{this.loading=false})
      },

        train: function(selected){

          this.annotations[this.itemIndex] = this.items
          var selectedBatches = []
          for(var i in selected){
            selectedBatches.push(this.annotations[selected[i].batchNumber])
          }
        let formData = new FormData();
          
          console.log(selectedBatches)
          var aux = JSON.stringify(selectedBatches.flat(1))
          var annFile = new File([aux], "ficheiro", {type: "text/plain", lastModified: new Date()})
          var UTFile = new File(this.corpus.slice(this.batchNumber * this.batchsize, (this.batchNumber +1)*this.batchsize), "ficheiro", {type: "text/plain", lastModified: new Date()})
          formData.append("ficheiro", annFile)
          formData.append("ficheiro", UTFile)
          this.loading=true
 
        axios.post(dataAPI+'annotator/train/file',
          formData,
          {"timeout": 3000000},
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then((dados) => { 
          console.log(dados.data)
          this.annotations.push(dados.data)
          this.itemIndex = this.annotations.length -1
          this.items = this.annotations[this.itemIndex]
          this.batchNumber ++
          this.createSetences()
          this.loading=false

        })
        .catch((error)=>{this.loading=false})
      },

    removeNewLine(){
      this.annotations.forEach(e => e.forEach(e1 => e1.splice(1,e1.length-1)));
    },
    addNewLine(){
      this.annotations.forEach(e => e.forEach(e1 => e1.push(["\n", "O", ""])))
    },
    innerEntity:function(){
      if(this.lineIndex == -1 || this.tokenIndex == -1){
        //alert("Hover a token to annotate it!")
        return;
      }
      if( this.items[this.lineIndex][this.tokenIndex -1] == undefined || this.items[this.lineIndex][this.tokenIndex-1][2] == ""){
        alert("Inner Entity needs a Begin!")
        return;
      }
      this.$set(this.items[this.lineIndex][this.tokenIndex], 2, this.items[this.lineIndex][this.tokenIndex-1][2])
        this.$set(this.items[this.lineIndex][this.tokenIndex], 1, 'I')
        var k = this.tokenIndex +1
      while(this.items[this.lineIndex][k] != undefined && this.items[this.lineIndex][k][1] == "I"){
          this.$set(this.items[this.lineIndex][k], 2, this.items[this.lineIndex][this.tokenIndex-1][2])
          k++;
      }

    },
    beginEntity:function(label){
      if(this.lineIndex == -1 || this.tokenIndex == -1){
        //alert("Hover a token to annotate it!")
        return
      }
      console.log(this.tokenIndex + " "+ this.lineIndex)
      this.$set(this.items[this.lineIndex][this.tokenIndex], 2, label)
      this.$set(this.items[this.lineIndex][this.tokenIndex], 1, 'B')
      var i = this.tokenIndex + 1
      while(this.items[this.lineIndex][i][1] == "I"){
        this.$set(this.items[this.selectedLineIndex][i], 2, label)
        //this.$set(this.items[this.selectedLineIndex][i], 1 ,"O")
        i++
      }
    },
    annotate: function(i,j,label,bio){
      console.log("ff")
        this.$set(this.items[i][j], 1, bio)
        this.$set(this.items[i][j], 2, label)
    },
    annotateSelection(label){
            var i = this.minN
           this.$set(this.items[this.selectedLineIndex][i], 1 ,"B")
           this.$set(this.items[this.selectedLineIndex][i], 2 ,label)
            i++
          while(i<=this.maxN){
             this.$set(this.items[this.selectedLineIndex][i], 2, label)
             this.$set(this.items[this.selectedLineIndex][i], 1 ,"I")
            i++
          }
          while(this.items[this.selectedLineIndex][i][1] == "I"){
              this.$set(this.items[this.selectedLineIndex][i], 2, "")
              this.$set(this.items[this.selectedLineIndex][i], 1 ,"O")
              i++
          }
    },
    removeAnnotation: function(i,j){
        this.$set(this.items[i][j], 1, 'O')
        this.$set(this.items[i][j], 2, '')
        var k = j+1
        while(this.items[i][k] != undefined && this.items[i][k][1] == 'I'){
          this.$set(this.items[i][k], 1, 'O')
          this.$set(this.items[i][k], 2, '')
          k++
        }
    },
    getLabelColor:function(i,j){
      if(this.items[i][j][2] == this.label1)
        return this.label1Color
      if(this.items[i][j][2] == this.label2)
        return this.label2Color
      if(this.items[i][j][2] == this.label3)
        return this.label3Color
      if(this.items[i][j][2] == this.label4)
        return this.label4Color
      if(this.items[i][j][2] == this.label5)
        return this.label5Color
    },
    accept:function(){
      if(this.selectedLineIndex < this.items.length -1)
        this.selectedLineIndex ++;
    },
    back:function(){
      if(this.selectedLineIndex > 0)
        this.selectedLineIndex --;
    },
    reject:function(){
      var aux = this.selectedLineIndex
      this.deleted.push(this.items[this.selectedLineIndex])
      if(this.selectedLineIndex == this.items.length -1)
        this.selectedLineIndex--;
      this.items.splice(aux,1)
      this.createSetences()
    },
    restore(i){
      this.items.push(this.deleted[i])
      this.deleted.splice(i,1)
      this.createSetences()
    },
    selectItems(index){
      this.annotations[this.itemIndex] = this.items
      this.itemIndex = index
      this.items = this.annotations[this.itemIndex] 
      this.createSetences()
    },
    createSetences: function(){
        var sentences= []
        var i = 0;
        var j = 0;
          for(i = 0; i<this.items.length ; i++){
            var aux = ""
              for(j = 0; j < this.items[i].length; j++){
                aux += " "+ this.items[i][j][0]
              }
              sentences.push(aux)
          }
          this.sentences = sentences        
      },


    
  },
  computed:{
     /* test: function () {
          this.newitems = JSON.parse(JSON.stringify(this.items))
        var i = 0;
        var j = 0;
        console.log(this.newitems)
        var k = 0;
          for(i = 0; i<this.items.length ; i++){
                console.log(this.items[i])
              for(j = 0; j < this.items[i].length; j++){
                console.log(this.items[i][j])
                  if(this.items[i][j][1] == 'B'){
                      k = j + 1
                      console.log("f")
                      
                      while(this.items[i][k] != undefined && this.items[i][k][1] == 'I'){
                          console.log("iii")
                        this.newitems[i][j][0] += " " +this.items[i][k][0]
                        k++
                      }  
                  }
              }
          }
          return this.newitems;         
      },*/
            processLine: function(){
        var i = this.selectedLineIndex
          if(this.items.length == 0) return
          var newLine = JSON.parse(JSON.stringify(this.items[i]))
            var j = 0;
            var k = 0;
              for(j = 0; j < this.items[i].length; j++){
                  if(this.items[i][j][1] == 'B'){
                      k = j + 1
                      while(this.items[i][k] != undefined && this.items[i][k][1] == 'I'){
                        newLine[j][0] += " " +this.items[i][k][0]
                        k++
                      }  
                  }
              }
          return newLine;         
      },

      
  },
  beforeRouteLeave (to, from , next) {
        if(this.annotations.length >0){
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
    else next()
}
};
</script>



<style scoped>
.loading {
    position: fixed;
    top: 0; right: 0;
    bottom: 0; left: 0;

    filter: alpha(opacity=40);
    z-index:1000000;

     background-color:rgb(236, 234, 234,0.4);
    z-index:100;

}
.loader {
    left: 50%;
    margin-left: -4em;
    font-size: 10px;
    border: .8em solid rgba(218, 219, 223, 1);
    border-left: .8em solid #AD8744;
    animation: spin 1.1s infinite linear;
    z-index:10000;
    opacity: 1;
    z-index:100;
}
.loader, .loader:after {
    border-radius: 50%;
    width: 8em;
    height: 8em;
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -4.05em;
    z-index:10000;
    opacity: 1;
    z-index:100;
}

@keyframes spin {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.entity{
 padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;
}

.v-text-field.v-text-field--solo .v-input__control { min-height: 10px; }
.v-text-field--box .v-input__slot, .v-text-field--outline .v-input__slot { min-height: 10px; }
</style>

